import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{
  height?: string
  width?: string
}>()((theme, { height, width }) => {
  return {
    pieWrapper: {
      display: 'flex',
      height: height ? height : theme.spacing(28),
      width: width ? width : theme.spacing(70.5),
    },
  }
})
